var map = {
	"./index.js": "XKlc",
	"./vistoria.js": "L8RX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zSB3";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/vistoria nonrecursive \.js$
// module id = zSB3
// module chunks = 5